import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import WarningIcon from "@mui/icons-material/DeleteOutline";
import { red } from "@mui/material/colors";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import CTLDialogContent from "../styles/CTLDialogContent";

export default function DeleteConfirmation({
  confirmDelete,
  onAgree,
  onCancel,
  entityName,
  columns,
  data,
  entityDescription,
}) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={confirmDelete}
      onClose={() => onCancel()}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: darkMode
            ? theme.palette.background.default
            : theme.palette.white.main,

          px: 3,
          py: 3,
          width: { xs: 370, md: 460 },
          boxShadow: theme.shadows[5],
          border: darkMode ? "1px solid #2c2c3e" : "1px solid #d1d5db",
        },
      }}
    >
      <Box display="flex" justifyContent="center" mb={2}>
        <Box
          sx={{
            p: 2,
            bgcolor: red[100],
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <WarningIcon sx={{ color: red[600], fontSize: 28 }} />
        </Box>
      </Box>

      <DialogTitle sx={{ p: 0, textAlign: "center" }}>
        {!entityDescription && (
          <Typography variant="h6" fontWeight={600} color="text">
            Are you sure?
          </Typography>
        )}
      </DialogTitle>

      <DialogContent
        sx={{
          mt: 1,
          p: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {entityDescription ? (
          entityDescription
        ) : (
          <Typography variant="body2" color="text" textAlign="center">
            Do you really want to continue? This action
            <br />
            cannot be undone.
          </Typography>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          mt: 3,
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexDirection: { xs: "column", md: "row" },
          px: 0,
        }}
      >
        <MDButton
          onClick={() => onCancel()}
          variant="outlined"
          color="text"
          sx={{
            width: { xs: "100%", md: 140 },
            height: 40,
            fontWeight: 500,
            fontSize: 14,
            textTransform: "none",
            borderColor: "#d1d5db",
            "&:hover": {
              backgroundColor: "#f3f4f6",
              color: "#111827",
              borderColor: "#d1d5db",
            },
          }}
        >
          Cancel
        </MDButton>

        <MDButton
          onClick={() => onAgree(data)}
          variant="outlined"
          color="error"
          sx={{
            width: { xs: "100%", md: 140 },
            height: 40,
            fontWeight: 500,
            fontSize: 14,
            textTransform: "none",
            "&:hover": {
              backgroundColor: red[700],
              color: "#fff",
              borderColor: red[700],
            },
          }}
        >
          Confirm
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
